export enum TrialBalanceReportType {
UnAdjusted,
Adjusted,
PostClosing,
}
